import Pagination from '@/modules/core/model/Pagination'
import KeyValuePair from '@/modules/core/support/KeyValuePair'

/**
 * Función de ayuda para generar mutaciones de paginaciones
 * @param path
 */
export function setPagination (path: string) {
    return (state: KeyValuePair, pagination: Pagination<any>) => {
        state[path] = pagination
    }
}
